import { useQuery } from "@tanstack/react-query";

import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import { useRuvixxFlags } from "providers/RuvixxFlagsProvider";
import { swoogoKeys } from "routes/swoogo/queryKeys";
import SwoogoService from "services/Swoogo";

const SYNC_POLL_INTERVAL_MS = 5_000;

// A stale session can return 403 for this background request on an unrelated
// page, so the global forbidden modal is suppressed.
const STATUS_REQUEST_OPTIONS = { suppressForbiddenModal: true };

export default function useSwoogoConnected() {
  const { enable_swoogo_integration } = useRuvixxFlags();
  const canReadStatus = useAuthorized([ACL_RELATIONSHIPS.swoogo.readStatus]);

  const { data, isLoading } = useQuery({
    queryKey: swoogoKeys.status(),
    queryFn: () => SwoogoService.getStatus(STATUS_REQUEST_OPTIONS),
    enabled: Boolean(enable_swoogo_integration) && canReadStatus,
    staleTime: 60_000,
    refetchInterval: query =>
      query.state.data?.sync_status === "pending"
        ? SYNC_POLL_INTERVAL_MS
        : false,
  });

  return {
    connectionId: data?.connection_id ?? null,
    isConnected: Boolean(data?.is_configured),
    isLoading,
    canSync: Boolean(data?.can_sync),
    syncStatus: data?.sync_status ?? "never",
    lastSyncedAt: data?.last_synced_at ?? null,
    syncError: data?.sync_error ?? null,
    accountName: data?.account_name ?? null,
    syncSkippedCount: data?.sync_skipped_count ?? 0,
    syncSkipped: data?.sync_skipped ?? [],
  };
}
